import { render, staticRenderFns } from "./VrIcon.vue?vue&type=template&id=51f02f00&"
import script from "./VrIcon.vue?vue&type=script&lang=js&"
export * from "./VrIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../visual/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports